export enum SmsMessageType {
    OTP = 0,
    Support = 1,
    ServiceRequests = 3,
    Other = 4
}